var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"active-color":"#13ce66"},on:{"change":_vm.change},model:{value:(_vm.sValue),callback:function ($$v) {_vm.sValue=$$v},expression:"sValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }